import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import JellyfishTabState from './JellyfishTabState';
import JellyfishView from './JellyfishView';

export default class JellyfishTabView extends Backbone.View<JellyfishTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  render(): this {
    const id = this.model.get('id');
    renderToDOM(<JellyfishView id={id} />, this.el);
    return this;
  }

  remove(): Backbone.View<JellyfishTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

JellyfishTabView.initClass();
